(function() {
  var store;
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  store = window.Store || (window.Store = {});
  store.Views = store.Views || (store.Views = {});
  store.Views.ProductThumbView = Backbone.View.extend({
    totalImages: 0,
    index: 0,
    currentImage: 0,
    initialize: function(options) {
      this.$el = $(this.el);
      this.index = Number(this.$el.attr('data-index'));
      this.appModel = options.appModel;
      this.appModel.bind('collection-image-fade', __bind(function() {
        this.nextImage();
      }, this));
      this.appModel.bind('change-state', __bind(function() {
        this.destroy();
      }, this));
      this.totalImages = this.$('.image').length;
      this.showImage(0);
    },
    nextImage: function() {
      if (this.currentImage + 1 < this.totalImages) {
        this.showImage(this.currentImage + 1);
      } else {
        this.showImage(0);
      }
    },
    showImage: function(currentImage) {
      var $img, delay, speed;
      this.currentImage = currentImage;
      speed = 0;
      delay = this.index * 100;
      $img = this.$('.image-' + this.currentImage);
      setTimeout(__bind(function() {
        this.$('.visible').each(function() {
          $(this).addClass('older');
          $(this).fadeTo(speed, 0, 'easeOutQuint', function() {
            $(this).removeClass('visible');
            $(this).removeClass('older');
          });
        });
        $img.addClass('visible');
        $img.fadeTo(0, 0).fadeTo(speed, 1, 'easeOutQuint');
      }, this), delay);
    },
    destroy: function() {
      this === {};
    }
  });
}).call(this);
